import {
  ProgressBar,
  Progress
} from './styles'

const Component = ({ current, total, showNumber = false }) => {
  const percentageProgress = (current / total) * 100 || 0; // Calculate the percentage progress

  const normalizedPercentage = Math.min(Math.max(percentageProgress, 0), 100); // Ensure the value is between 0 and 100
  const progressBarStyle = {
    width: `${normalizedPercentage}%`,
  };

  return (
    <ProgressBar>
      <Progress style={progressBarStyle} />
    </ProgressBar>
  );
};

export default Component;
